export const LOAD_PROPERTIES_STARTED = "LOAD_PROPERTIES_STARTED";
export const LOAD_PROPERTIES_SUCCEEDED = "LOAD_PROPERTIES_SUCCEEDED";
export const LOAD_PROPERTIES_FAILED = "LOAD_PROPERTIES_FAILED";
export const UPDATE_PROPERTIES_SUCCEEDED = "UPDATE_PROPERTIES_SUCCEEDED";
export const UPDATE_PROPERTIES_FAILED = "UPDATE_PROPERTIES_FAILED";
export const UPDATE_PROPERTIES_STARTED = "UPDATE_PROPERTIES_STARTED";

export const LOAD_PROPERTY_DETAILS_STARTED = "LOAD_PROPERTY_DETAILS_STARTED";
export const LOAD_PROPERTY_DETAILS_SUCCEEDED = "LOAD_PROPERTY_DETAILS_SUCCEEDED";
export const LOAD_PROPERTY_DETAILS_FAILED = "LOAD_PROPERTY_DETAILS_FAILED";
